import { render, staticRenderFns } from "./pagespecificDetail.vue?vue&type=template&id=4fcd90d5&scoped=true&"
import script from "./pagespecificDetail.vue?vue&type=script&lang=js&"
export * from "./pagespecificDetail.vue?vue&type=script&lang=js&"
import style0 from "./pagespecificDetail.vue?vue&type=style&index=0&id=4fcd90d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd90d5",
  null
  
)

export default component.exports